<script setup lang="ts">
import { computed } from 'vue';

import type { MenuForm } from './globals';
import { formUrl, isActive } from './util';

const props = defineProps<{
    form: MenuForm;
}>();

const xfm = computed(() => props.form);
const ROOT = __ROOT__;
const APP_VERSION_QS = __APP_VERSION_QS__;

</script>

<template>
    <li :class="isActive(formUrl(xfm.path)) ? 'active' : ''">
        <a
            class="menu-item"
            :href="formUrl(xfm.path)"
        >
            <img v-if="xfm.icon" width="32" height="32" :src="`${ROOT}images/${xfm.icon}?${APP_VERSION_QS}`">
            {{ xfm.label }}
        </a>
    </li>
</template>
